export default __webpack_public_path__ + "static/media/coinsdown.a8674044.png";